import React, { useEffect, useState } from 'react';
import MUILink from '@mui/material/Link';
import { Box, Typography, Breadcrumbs } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { settingsClose } from '../../redux/reducers/companySkipSave';
import { useThemes } from '../Theme/theme';
import useControlledNavigation from '../../hooks/useControlledNavigation';

const NavBreadCrumbs = ({ setIsDrawerOpen }) => {
  const { theme } = useThemes();

  const dispatch = useDispatch();
  const navigate = useControlledNavigation();
  const [pageHeaderTitle, setPageHeaderTitle] = useState('Business Overview');
  const [pageTitle, setPageTitle] = useState('');
  const [pageLink, setPageLink] = useState('');
  const [pageBreadCrumbLink, setPageBreadCrumbLink] = useState('');
  const { saveSkipStatus } = useSelector((state) => state.companySipSaveReducer);

  const handleSaveSkipStatus = () => {
    if (saveSkipStatus === false) {
      dispatch(settingsClose());
      navigate('/companysetup');
    }
  };
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const titleParams = queryParams.get('title');

  const title = useSelector((state) => state.title.value);

  useEffect(() => {
    const url = window.location.href;

    const pathname = new URL(url).pathname;
    const valueAfterView = pathname.split('/')[2];

    setPageTitle((prev) => {
      if (valueAfterView) {
        return valueAfterView;
      }
      return title;
    });
  }, [title]);

  const exportBreadcrumbCheck = (link) => {
    if (link.includes('item')) {
      setPageHeaderTitle('export');
      setPageTitle('export items');
      setPageLink('List of Items');
      setPageBreadCrumbLink('/newItemList');
    } else if (link.includes('customer')) {
      setPageHeaderTitle('export');
      setPageTitle('export customers');
      setPageLink('List of Customers');
      setPageBreadCrumbLink('/customerList');
    } else if (link.includes('supplier')) {
      setPageHeaderTitle('export');
      setPageTitle('export suppliers');
      setPageLink('List of Suppliers');
      setPageBreadCrumbLink('/supplierList');
    } else if (link.includes('sales')) {
      setPageHeaderTitle('export');
      setPageTitle('export sales');
      setPageLink('List of Sales Invoices');
      setPageBreadCrumbLink('/salesInvoiceReport');
    } else if (link.includes('payment')) {
      setPageHeaderTitle('export');
      setPageTitle('export payments');
      setPageLink('List of Payments');
      setPageBreadCrumbLink('/paymententries');
    } else if (link.includes('receipt')) {
      setPageHeaderTitle('export');
      setPageTitle('export receipts');
      setPageLink('List of Receipts');
      setPageBreadCrumbLink('/receipts');
    } else {
      // Default case for other exports
      setPageHeaderTitle('export');
      setPageTitle('export');
      setPageLink('Home');
      setPageBreadCrumbLink('/');
    }
  };
  console.log(pageBreadCrumbLink, 'pageBreadCrumbLink');
  console.log(pageLink, 'pageLink');

  useEffect(() => {
    if (window.location.href.indexOf('supportpage') > 0) {
      setPageHeaderTitle('Support');
      setPageTitle('Support');
      setPageLink('Home');
    } else if (window.location.href.indexOf('companysetup') > 0) {
      setPageHeaderTitle('Company setup');
      setPageTitle('Company setup');
      setPageLink('Home');
    } else if (window.location.href.indexOf('additem') > 0) {
      setPageHeaderTitle('Add New Item');
      setPageTitle('Add New');
      setPageBreadCrumbLink('/newItemList');
      setPageLink('List of Items');
    } else if (window.location.href.indexOf('goodslist') > 0) {
      setPageHeaderTitle('List of Goods');
      setPageTitle('List of Goods');
      setPageLink('Home');
    } else if (window.location.href.indexOf('serviceslist') > 0) {
      setPageHeaderTitle('List of Services');
      setPageTitle('List of Services');
      setPageLink('Home');
    } else if (window.location.href.indexOf('addgoods') > 0) {
      setPageBreadCrumbLink('/goodslist');
      setPageHeaderTitle('Add New Goods');
      setPageTitle('Add New');
      setPageLink('List of Goods');
      handleSaveSkipStatus();
    } else if (window.location.href.indexOf('edititem') > 0) {
      // setPageHeaderTitle(`${JSON.parse(title).name} (${JSON.parse(title).type == 1 ? 'GOODS' : 'SERVICES'})`);
      setPageHeaderTitle(`${title} (GOODS)`);
      // setPageTitle(JSON.parse(title).name);
      setPageLink('List of Items');
      setPageBreadCrumbLink('/newItemList');
    } else if (window.location.href.indexOf('viewitem') > 0) {
      // setPageHeaderTitle(`${JSON.parse(title).name} (${JSON.parse(title).type == 1 ? 'GOODS' : 'SERVICES'})`);
      setPageHeaderTitle(`${title}`);
      // setPageTitle(JSON.parse(title).name);
      setPageLink('List of Items');
      setPageBreadCrumbLink('/newItemList');
    } else if (window.location.href.indexOf('addservices') > 0) {
      setPageHeaderTitle('Add New Services ');
      setPageTitle('Add New');
      setPageLink('List of Items');
      setPageBreadCrumbLink('/serviceslist');
      handleSaveSkipStatus();
    } else if (window.location.href.indexOf('editservices') > 0) {
      // setPageHeaderTitle(`Service (${title})`);
      setPageHeaderTitle(`${title} (Service)`);
      // setPageTitle(title);
      setPageLink('List of Items');
      setPageBreadCrumbLink('/serviceslist');
    } else if (window.location.href.indexOf('viewservices') > 0) {
      setPageBreadCrumbLink('/serviceslist');
      setPageHeaderTitle(`${title} (Service)`);
      // setPageTitle(title);
      setPageLink('List of Items');
    } else if (window.location.href.indexOf('customerList') > 0) {
      setPageHeaderTitle('List of Customers (Debtors)');
      setPageTitle('List of Customers');
      setPageLink('Home');
    } else if (window.location.href.indexOf('addcustomer') > 0) {
      setPageHeaderTitle('Add New Customer (Debtor)');
      setPageBreadCrumbLink('/customerList');
      setPageTitle('Add New');
      setPageLink('List of Customers');
      handleSaveSkipStatus();
    } else if (window.location.href.indexOf('editcustomer') > 0) {
      setPageHeaderTitle(`${title} (Debtor)`);
      // setPageTitle(title);
      setPageLink('List of Customers');
      setPageBreadCrumbLink('/customerList');
    } else if (window.location.href.indexOf('viewcustomer') > 0) {
      setPageHeaderTitle(`${titleParams || title} (Debtor)`);
      // setPageTitle(titleParams || title);
      setPageLink('List of Customers');
      setPageBreadCrumbLink('/customerList');
    } else if (window.location.href.indexOf('supplierList') > 0) {
      setPageHeaderTitle('List of Suppliers (Creditors)');
      setPageTitle('List of Suppliers');
      setPageLink('Home');
    } else if (window.location.href.indexOf('addsupplier') > 0) {
      setPageBreadCrumbLink('/supplierList');
      setPageHeaderTitle('Add New Supplier (Creditor)');
      setPageTitle('Add New');
      setPageLink('List of Suppliers');
      handleSaveSkipStatus();
    } else if (window.location.href.indexOf('editsupplier') > 0) {
      setPageHeaderTitle(`${title} (Creditors)`);
      // setPageTitle(title);
      setPageBreadCrumbLink('/supplierList');
      setPageLink('List of Suppliers');
    } else if (window.location.href.indexOf('viewsupplier') > 0) {
      setPageHeaderTitle(`${titleParams || title} (Creditors)`);
      // setPageTitle(titleParams || title);
      setPageBreadCrumbLink('/supplierList');
      setPageLink('List of Suppliers');
    } else if (window.location.href.indexOf('allpurchaseandexpense') > 0) {
      setPageHeaderTitle('List of Purchases & Expenses');
      setPageTitle('List of Purchases & Expenses');
      setPageLink('Home');
    } else if (window.location.href.indexOf('newItemList') > 0) {
      setPageHeaderTitle('List of Goods & Services');
      setPageTitle('List of Goods & Services');
      setPageLink('Home');
    } else if (window.location.href.indexOf('addnewpurchasetax') > 0) {
      setPageHeaderTitle('Add New Purchase & Expense');
      setPageBreadCrumbLink('/allpurchaseandexpense');
      setPageTitle('Add New');
      setPageLink('List of Purchases/Expenses');
      handleSaveSkipStatus();
    } else if (window.location.href.indexOf('LedgerTransactions') > 0) {
      setPageHeaderTitle('Ledger Transactions');
      setPageTitle('View Transactions');
      setPageLink('Home');
    } else if (window.location.href.indexOf('viewnewpurchasetax') > 0) {
      setPageHeaderTitle(`Purchase/Expense`);
      // setPageTitle(title);
      setPageBreadCrumbLink('/allpurchaseandexpense');
      setPageLink('List of Purchases/Expenses');
    } else if (window.location.href.indexOf('editnewpurchasetax') > 0) {
      setPageBreadCrumbLink('/allpurchaseandexpense');
      setPageHeaderTitle(`Purchase/Expense`);
      setPageLink('List of Purchases/Expenses');
      // setPageTitle(title);
    } else if (window.location.href.indexOf('addpurchaseandexpensenontaxable') > 0) {
      setPageHeaderTitle('Add New Purchase & Expense');
      setPageTitle('Add New');
      setPageLink('List of Purchases/Expenses');
      handleSaveSkipStatus();
    } else if (window.location.href.indexOf('editpurchaseandexpensenontaxable') > 0) {
      setPageHeaderTitle(`Purchase/Expense (${title})`);
      // setPageTitle(title);
      setPageLink('List of Purchases/Expenses');
    } else if (window.location.href.indexOf('viewpurchaseandexpensenontaxable') > 0) {
      setPageHeaderTitle(`Purchase/Expense`);
      // setPageTitle(title);
      setPageLink('List of Purchases/Expenses');
    } else if (window.location.href.indexOf('salesInvoiceReport') > 0) {
      setPageBreadCrumbLink('/salesInvoiceReport');
      setPageHeaderTitle('List of Sales invoices');
      setPageTitle('List of Sales invoices');
      setPageLink('Home');
    } else if (window.location.href.indexOf('addinvoiceTaxable') > 0) {
      setPageBreadCrumbLink('/salesInvoiceReport');
      setPageHeaderTitle('Add New');
      setPageLink('List of Sales Invoices');
      // setPageTitle(title);
      handleSaveSkipStatus();
    } else if (window.location.href.indexOf('exports') > 0) {
      exportBreadcrumbCheck(window.location.href);
    } else if (window.location.href.indexOf('editinvoiceTaxable') > 0) {
      setPageBreadCrumbLink('/salesInvoiceReport');
      setPageHeaderTitle(`Sales Invoice (${title})`);
      setPageLink('List of Sales Invoices');
      // setPageTitle(title);
    } else if (window.location.href.indexOf('viewinvoiceTaxable') > 0) {
      setPageBreadCrumbLink('/salesInvoiceReport');
      // setPageTitle(title);
      setPageLink('List of Sales Invoices');
      setPageHeaderTitle(`Sales Invoice (${title})`);
    } else if (window.location.href.indexOf('addinvoiceNonTaxable') > 0) {
      setPageHeaderTitle('Add New Sales Invoice');
      setPageBreadCrumbLink('/salesInvoiceReport');
      handleSaveSkipStatus();
      setPageLink('List of Sales Invoices');
      setPageTitle('Add New');
    } else if (window.location.href.indexOf('addnewinvoicetax') > 0) {
      setPageHeaderTitle('Add New Sales Invoice');
      setPageBreadCrumbLink('/salesInvoiceReport');
      setPageTitle('Add New');
      setPageLink('List of Sales Invoices');
      handleSaveSkipStatus();
    } else if (window.location.href.indexOf('editnewinvoicetax') > 0) {
      setPageHeaderTitle(`Sales Invoice`);
      // setPageTitle(title);
      setPageLink('List of Sales Invoices');
    } else if (window.location.href.indexOf('viewnewinvoicetax') > 0) {
      setPageBreadCrumbLink('/salesInvoiceReport');
      setPageHeaderTitle(`Sales Invoice`);
      // setPageTitle(title);

      setPageLink('List of Sales Invoices');
    } else if (window.location.href.indexOf('editinvoiceNonTaxable') > 0) {
      setPageBreadCrumbLink('/salesInvoiceReport');
      setPageHeaderTitle(`Sales Invoice`);
      // setPageTitle(title);
      setPageLink('List of Sales Invoices');
    } else if (window.location.href.indexOf('viewinvoiceNonTaxable') > 0) {
      setPageBreadCrumbLink('/salesInvoiceReport');
      setPageHeaderTitle(`Sales Invoice`);
      // setPageTitle(title);
      setPageLink('List of Sales Invoices');
    } else if (window.location.href.indexOf('newpos') > 0) {
      setPageHeaderTitle('Add New Pos Invoice');
      setPageTitle('Add New');
      setPageLink('List of POS Invoices/');
      setPageBreadCrumbLink('/allpos');
      handleSaveSkipStatus();
    } else if (window.location.href.indexOf('editpos') > 0) {
      setPageHeaderTitle('POS Invoice');
      // setPageTitle(title);
      setPageLink('List of POS Invoices');
      setPageBreadCrumbLink('/allpos');
    } else if (window.location.href.indexOf('viewpos') > 0) {
      setPageHeaderTitle(`POS Invoice`);
      // setPageTitle(title);
      setPageLink('List of POS Invoices');
      setPageBreadCrumbLink('/allpos');
    } else if (window.location.href.indexOf('addpaymententries') > 0) {
      setPageHeaderTitle('Add New Payment Voucher');
      setPageBreadCrumbLink('/paymententries');
      setPageTitle('Add New');
      setPageLink('List of Payments');
      handleSaveSkipStatus();
    } else if (window.location.href.indexOf('editpaymententries') > 0) {
      setPageHeaderTitle(`Payment voucher`);
      // setPageTitle(title);
      setPageLink('List of Payments');
      setPageBreadCrumbLink('/paymententries');
    } else if (window.location.href.indexOf('viewpaymententries') > 0) {
      setPageHeaderTitle(`Payment voucher`);
      // setPageTitle(title);
      setPageLink('List of Payments');
      setPageBreadCrumbLink('/paymententries');
    } else if (window.location.href.indexOf('paymententries') > 0) {
      setPageHeaderTitle('List of Payment Entries');
      setPageTitle('List of Payment Entries');
      setPageLink('Home');
    } else if (window.location.href.indexOf('addreceipts') > 0) {
      setPageHeaderTitle('Add New Receipt Voucher');
      setPageBreadCrumbLink('/receipts');
      setPageLink('List of Receipts');
      setPageTitle('Add New');
      handleSaveSkipStatus();
    } else if (window.location.href.indexOf('editreceipts') > 0) {
      setPageHeaderTitle(`Receipt voucher`);
      // setPageTitle(title);
      setPageLink('List of Receipts');
      setPageBreadCrumbLink('/receipts');
    } else if (window.location.href.indexOf('viewreceipts') > 0) {
      setPageHeaderTitle(`Receipt voucher`);
      // setPageTitle(title);
      setPageLink('List of Receipts');
      setPageBreadCrumbLink('/receipts');
    } else if (window.location.href.indexOf('receipts') > 0) {
      setPageHeaderTitle('List of Receipts');
      setPageTitle('List of Receipts');
      setPageLink('Home');
    } else if (window.location.href.indexOf('journalentries') > 0) {
      setPageHeaderTitle('List of Journal Entries');
      setPageTitle('List of Journal Entries');
      setPageLink('Home');
    } else if (window.location.href.indexOf('addjournalentry') > 0) {
      setPageHeaderTitle('Add New Journal Entries');
      setPageTitle('Add New');
      setPageBreadCrumbLink('/journalentries');
      setPageLink('List of Journal Entries');
      handleSaveSkipStatus();
    } else if (window.location.href.indexOf('editjournalentry') > 0) {
      setPageHeaderTitle(`Journal Entry voucher`);
      // setPageTitle(title);
      setPageLink('List of Journal Entries');
      setPageBreadCrumbLink('/journalentries');
    } else if (window.location.href.indexOf('viewjournalentry') > 0) {
      setPageHeaderTitle(`Journal Entry voucher`);
      // setPageTitle(title);
      setPageLink('List of Journal Entries');
      setPageBreadCrumbLink('/journalentries');
    } else if (window.location.href.indexOf('openingbalance') > 0) {
      setPageHeaderTitle('List of Opening Balance');
      setPageTitle('List of Opening Balance');
      setPageLink('Home');
    } else if (window.location.href.indexOf('reports') > 0) {
      setPageHeaderTitle('List of Reports');
      setPageTitle('List of Reports');
      setPageLink('Home');
    } else if (window.location.href.indexOf('defaultformats') > 0) {
      setPageHeaderTitle('Default Formats');
      setPageTitle('Default Formats');
      setPageLink('Home');
    } else if (window.location.href.indexOf('financialyearsettings') > 0) {
      setPageHeaderTitle('Financial Year Settings');
      setPageTitle('Financial Year Settings');
      setPageLink('Home');
    } else if (window.location.href.indexOf('alldebitnote') > 0) {
      setPageHeaderTitle('List of Debit Notes');
      setPageTitle('List of Debit Notes');
      setPageLink('Home');
    } else if (window.location.href.indexOf('editdebitnote') > 0) {
      setPageHeaderTitle(`Debit Note/ Purchase Return`);
      // setPageTitle(title);
      setPageLink('List of Debit Notes');
      setPageBreadCrumbLink('/alldebitnote');
    } else if (window.location.href.indexOf('viewdebitnote') > 0) {
      setPageHeaderTitle(`Debit Note/ Purchase Return`);
      // setPageTitle(title);
      setPageLink('List of Debit Notes');
      setPageBreadCrumbLink('/alldebitnote');
    } else if (window.location.href.indexOf('adddebitnote') > 0) {
      setPageHeaderTitle(' Add New Debit Note/ Purchase Return');
      setPageTitle(' Add New');
      setPageLink('List of Debit Notes');
      setPageBreadCrumbLink('/alldebitnote');
      handleSaveSkipStatus();
    } else if (window.location.href.indexOf('allcreditnote') > 0) {
      setPageHeaderTitle('List of Credit Notes');
      setPageTitle('List of Credit Notes');
      setPageLink('Home');
      setPageBreadCrumbLink('/allcreditnote');
    } else if (window.location.href.indexOf('editcreditnote') > 0) {
      setPageHeaderTitle(`Credit Note/Sales Return`);
      // setPageTitle(title);
      setPageLink('List of Credit Notes');
      setPageBreadCrumbLink('/allcreditnote');
    } else if (window.location.href.indexOf('viewcreditnote') > 0) {
      setPageHeaderTitle(`Credit Note/Sales Return`);
      // setPageTitle(title);
      setPageLink('List of Credit Notes');
      setPageBreadCrumbLink('/allcreditnote');
    } else if (window.location.href.indexOf('addcreditnote') > 0) {
      setPageHeaderTitle('Add New Credit Note/Sales Return ');
      setPageTitle('Add New');
      setPageBreadCrumbLink('/allcreditnote');
      setPageLink('List of Credit Notes');
      handleSaveSkipStatus();
    } else if (window.location.href.indexOf('closebooksofaccounts') > 0) {
      setPageHeaderTitle('Close Books Of Accounts');
      setPageTitle('Close Books Of Accounts');
      setPageLink('Home');
    } else if (window.location.href.indexOf('closefinancialyear') > 0) {
      setPageHeaderTitle('Close Financial Year');
      setPageTitle('Close Financial Year');
      setPageLink('Home');
    } else if (window.location.href.indexOf('emailsettings') > 0) {
      setPageHeaderTitle('Email Settings');
      setPageTitle('Email Settings');
      setPageLink('Home');
    } else if (window.location.href.indexOf('import-data') > 0) {
      setPageHeaderTitle('Import Data');
      setPageTitle('Import Data');
      setPageLink('Home');
    } else if (window.location.href.indexOf('addrecurringinvoice') > 0) {
      setPageHeaderTitle('Recurring Invoice');
      setPageTitle('Recurring Invoice');
      setPageLink('Home');
      handleSaveSkipStatus();
    } else if (window.location.href.indexOf('active=ProfitAndLoss') > 0) {
      setPageHeaderTitle('Profit & Loss');
      setPageTitle('Profit & Loss');
      setPageLink('Home');
    } else if (window.location.href.indexOf('active=BalanceSheet') > 0) {
      setPageHeaderTitle('BalanceSheet');
      setPageTitle('BalanceSheet');
      setPageLink('Home');
    } else if (window.location.href.indexOf('active=Business_Overview') > 0) {
      setPageHeaderTitle('Business Overview');
      setPageTitle('Business Overview');
      setPageLink('Home');
    } else if (window.location.href.indexOf('active=Receivables') > 0) {
      setPageHeaderTitle('Receivables');
      setPageTitle('Receivables');
      setPageLink('Home');
    } else if (window.location.href.indexOf('active=Payables') > 0) {
      setPageHeaderTitle('Payables');
      setPageTitle('Payables');
      setPageLink('Home');
    } else if (window.location.href.indexOf('active=TrialBalance') > 0) {
      setPageHeaderTitle('TrialBalance');
      setPageTitle('TrialBalance');
      setPageLink('Home');
    } else if (window.location.href.indexOf('active=Items') > 0) {
      setPageHeaderTitle('Items');
      setPageLink('Home');
      setPageTitle('Items');
    } else if (window.location.href.indexOf('/accounts') > 0) {
      setPageHeaderTitle('List of Ledgers');
      setPageTitle('List of Ledgers');
      setPageLink('Home');
    } else if (window.location.href.indexOf('/groups') > 0) {
      setPageHeaderTitle('List of Groups');
      setPageTitle('List of Groups');
      setPageLink('Home');
    } else if (window.location.href.indexOf('/invoiceSettings') > 0) {
      setPageHeaderTitle('Invoice Settings');
      setPageTitle('Invoice Settings');
      setPageLink('Home');
    } else if (window.location.href.indexOf('financial-year') > 0) {
      setPageHeaderTitle('Financial Year Creation');
      setPageTitle('Financial Year Creation');
      setPageLink('Home');
    } else if (window.location.href.indexOf('PaymentSettings') > 0) {
      setPageHeaderTitle('Payment Settings');
      setPageTitle('Payment Settings');
      setPageLink('Home');
    } else if (window.location.href.indexOf('ItemSettings') > 0) {
      setPageHeaderTitle('Item Settings');
      setPageTitle('Item Settings');
      setPageLink('Home');
    } else if (window.location.href.indexOf('AddItem') > 0) {
      setPageHeaderTitle('List of Items');
      setPageTitle('List of Items');
      setPageLink('Home');
      handleSaveSkipStatus();
      // } else if (window.location.href.indexOf("newpos") > 0) {
      //   setPageHeaderTitle("Add New Pos Invoice");
      //   setPageTitle("Add New");
      //   setPageLink("List of Pos Invoices");
      //   handleSaveSkipStatus();
      // } else if (window.location.href.indexOf("editpos") > 0) {
      //   setPageHeaderTitle(`Pos Invoice`);
      //   setPageTitle(title);
      //   setPageLink("List of Pos Invoices");
      // } else if (window.location.href.indexOf("viewpos") > 0) {
      //   setPageHeaderTitle(`Pos Invoice`);
      //   setPageTitle(title);
      //   setPageLink("List of Pos Invoices");
    } else if (window.location.href.indexOf('edititem') > 0) {
      setPageHeaderTitle(`Add GOODS/SERVICES`);
      // setPageTitle(title);
      setPageLink('List of Items');
    } else if (window.location.href.indexOf('stock-item-wise-pl') > 0) {
      setPageHeaderTitle(`Stock & Item wise P&L`);
      setPageTitle(' Stock & Item wise Profit & Loss Report');
      setPageLink('Home');
      setPageBreadCrumbLink('/reports');
    } else if (window.location.href.indexOf('inventory-transaction-summary') > 0) {
      setPageHeaderTitle(`Inventory Transaction Summary`);
      setPageTitle('Inventory Transaction Summary Report');
      setPageLink('Home');
      setPageBreadCrumbLink('/reports');
    } else if (window.location.href.indexOf('allSales') > 0) {
      setPageHeaderTitle(`All Sales`);
      setPageTitle('List of All Sales');
      setPageLink('Home');
    } else if (window.location.href.indexOf('allpos') > 0) {
      setPageHeaderTitle(`All POS`);
      setPageTitle('List of POS');
      setPageLink('Home');
    } else if (window.location.href.indexOf('addewaybill') > 0) {
      setPageHeaderTitle(`Create New E way`);
      setPageTitle('Create New');
      setPageLink('Home');
    } else if (window.location.href.indexOf('editewaybill') > 0) {
      setPageHeaderTitle(`E way bill Edit`);
      setPageTitle('E way bill');
      setPageLink('Home');
    } else if (window.location.href.indexOf('ewaybilllist') > 0) {
      setPageHeaderTitle(`List of E way bills`);
      setPageTitle('E way bills');
      setPageLink('Home');
    } else if (window.location.href.indexOf('exports') === -1) {
      setPageHeaderTitle('Business Overview');
      setPageTitle('Business Overview');
    }
  }, [window.location.href, title]);

  const url = window.location.href;
  // console.log(pageHeaderTitle, "pageHeaderTitle");
  return (
    <Box
      sx={{
        ml: 1,
        // mt: pageHeaderTitle == "Business Overview" ? "-4px" : 2,
      }}
    >
      <Typography
        variant="h6"
        noWrap
        component="div"
        // fontWeight='550'
        sx={{
          display: { xs: '', sm: 'block' },
          marginLeft: { md: '25px', lg: '30px' },
          textTransform: 'capitalize',
          // color : "#396afc",
          color: 'text.textClr',
          fontWeight: 'bold',
          fontSize: { xs: '11px', sm: '15px' },
        }}
      >
        {pageHeaderTitle}
        {/* {pageHeaderTitle == "" ? "Business Overview" : pageHeaderTitle} */}
      </Typography>
      {pageHeaderTitle !== '' && pageHeaderTitle !== 'Business Overview' && (
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{
            display: { xs: 'none', sm: 'block' },
            marginLeft: { md: '25px', lg: '30px' },
            // padding: "0px 10px",
            fontSize: '12px',
            // textTransform : "capitalize"
          }}
        >
          {pageLink === 'Home' ? (
            <Link
              id="BreadCrumbs"
              underline="none"
              style={{
                fontWeight: 800,
                color: theme.palette.text.Link,
                cursor: 'pointer !important',
              }}
              onClick={(e) => {
                e.preventDefault();
                navigate('/');
              }}
            >
              Home
            </Link>
          ) : (
            <Link
              id="BreadCrumbs"
              underline="none"
              style={{
                fontWeight: 800,
                color: theme.palette.text.Link,
                cursor: 'pointer !important',
              }}
              onClick={(e) => {
                e.preventDefault();
                navigate(pageBreadCrumbLink);
                setIsDrawerOpen(
                  pageHeaderTitle.toLowerCase().indexOf('default') > 0 ||
                    pageHeaderTitle.toLowerCase().indexOf('settings') > 0 ||
                    pageHeaderTitle.toLowerCase().indexOf('close') > 0
                    ? true
                    : false
                );
              }}
            >
              {pageHeaderTitle.indexOf('Add') >= 0
                ? pageLink
                : url.indexOf('view') >= 0
                  ? pageLink
                  : url.indexOf('edit') >= 0
                    ? pageLink
                    : pageHeaderTitle.toLowerCase().indexOf('export') >= 0
                      ? pageLink
                      : pageHeaderTitle.toLowerCase().indexOf('profit') >= 0 ||
                          pageHeaderTitle.toLowerCase().indexOf('balance') >= 0 ||
                          pageHeaderTitle.toLowerCase().indexOf('receivables') >= 0 ||
                          pageHeaderTitle.toLowerCase().indexOf('items') >= 0 ||
                          pageHeaderTitle.toLowerCase().indexOf('payables') >= 0
                        ? 'Dashboard'
                        : (pageHeaderTitle.toLowerCase().indexOf('default') >= 0 ||
                            pageHeaderTitle.toLowerCase().indexOf('settings') >= 0 ||
                            pageHeaderTitle.toLowerCase().indexOf('close') >= 0) &&
                          'Settings'}
            </Link>
          )}
          <Typography
            sx={{
              fontSize: '12px',
              color: 'inherit',
              '&:hover': {
                cursor: 'context-menu',
              },
            }}
          >
            {pageTitle}
          </Typography>
        </Breadcrumbs>
      )}
    </Box>
  );
};
export default NavBreadCrumbs;
